import { motion } from "framer-motion";

export const WA_NUMBER = "35677152198";
// CONFIG UNICA WHATSAPP — link ufficiale fornito da Elio
export const WA_LINK = "https://api.whatsapp.com/message/SPEKGVHMQJXPF1?autoload=1&app_absent=0";

export const openWhatsApp = () => window.open(WA_LINK, "_blank", "noopener");

export const IMAGES = {
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/lemcdoqr_WhatsApp%20Image%202026-09-12%20at%2012.35.33%20%284%29.jpeg",
  elioFitness: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/qgouokpp_WhatsApp%20Image%202026-09-12%20at%2012.35.33%20%283%29.jpeg",
  elioFamiglia: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/riwwqjot_WhatsApp%20Image%202026-09-12%20at%2012.35.33%20%282%29.jpeg",
  igProfile: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/da4a5787_WhatsApp%20Image%202026-10-01%20at%2008.45.03.jpeg",
  prima: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/4o00mxvm_WhatsApp%20Image%202026-10-01%20at%2008.35.37.webp",
  dopo: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/8eudhkz9_WhatsApp%20Image%202026-10-01%20at%2008.36.25.webp",
  finalCta: "https://static.prod-images.emergentagent.com/jobs/af6d6f15-fed9-46e4-9c3b-43850e001683/images/d3eb6a7b197afb37a903806dd2553b5348dd13b1fb70e8f0c10f04e8c02c758a.jpeg",
  story: "https://customer-assets-agu9un31.emergentagent.net/job_tempio-vivo-1/artifacts/vkluwpf5_WhatsApp%20Image%202026-09-12%20at%2014.47.08.jpeg",
  lion: "https://static.prod-images.emergentagent.com/jobs/af6d6f15-fed9-46e4-9c3b-43850e001683/images/5cd73491285bf2be17370d37ec4ba9dc0734e8ba8eaa1522d9ea2f2b9ef8987d.jpeg",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow ${className}`}>{children}</p>
);

export const GoldCta = ({ children, testId, onClick, className = "" }) => (
  <button
    data-testid={testId}
    onClick={onClick || openWhatsApp}
    className={`cta-gold rounded-full px-8 py-4 text-xs sm:text-sm uppercase ${className}`}
  >
    {children}
  </button>
);

export const GhostCta = ({ children, testId, onClick, className = "" }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`cta-ghost rounded-full px-8 py-4 text-xs sm:text-sm uppercase ${className}`}
  >
    {children}
  </button>
);

export const SectionShell = ({ id, children, className = "" }) => (
  <section id={id} className={`relative px-5 sm:px-10 lg:px-20 py-20 sm:py-28 lg:py-36 ${className}`}>
    <div className="max-w-6xl mx-auto">{children}</div>
  </section>
);
